"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Apple = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: 24, viewBox: '0 0 24 24', width: 24, xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("title", null, "Apple Icon"),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("path", { d: 'M14.878 6.342l.266.015c.594.017 2.287.23 3.38 1.784-.089.052-2.017 1.159-1.996 3.432C16.552 14.3 18.97 15.2 19 15.21c-.015.063-.379 1.3-1.286 2.555-.757 1.107-1.55 2.187-2.81 2.207-1.226.028-1.637-.704-3.042-.704-1.417 0-1.856.684-3.03.732-1.2.043-2.117-1.181-2.902-2.277-1.569-2.237-2.79-6.304-1.153-9.072.794-1.357 2.241-2.231 3.787-2.255 1.201-.024 2.317.792 3.055.792.725 0 2.103-.976 3.525-.831zM15.158 2c.12 1.065-.311 2.115-.942 2.886-.66.759-1.714 1.339-2.741 1.265-.134-1.025.387-2.115.969-2.779.658-.755 1.8-1.332 2.715-1.372z', fill: '#464650' }),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = Apple;
